import React, { Component } from "react";
import { Link } from "react-router-dom";
import treatment from "../../../data/treatments.json";
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} sliderTreatmentButton`}
      style={{ ...style, top: "47.5%", right: "-6rem" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} sliderTreatmentButton`}
      style={{ ...style, top: "47.5%", left: "-6rem" }}
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 3,
  autoplay: true,
  initialSlide: 0,
  pauseOnHover: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};
class Treatments extends Component {
  render() {
    return (
      <div className="container">
        <div className="slider-container">
          {/* Data */}
          <Slider {...settings} className="sigma_instagram-slider">
            {treatment.map((item, i) => {
              return (
                !Boolean(item.is_sub) && (
                  <div style={{ maxWidth: "350px" }} key={i}>
                    <div className="sigma_service style-17">
                      <div className="sigma_service-thumb">
                        <img
                          src={process.env.PUBLIC_URL + "/" + item.image}
                          alt={item.title}
                        />
                      </div>
                      <div className="sigma_service-body">
                        <h5>
                          <Link to={"/treatment/" + item.id}>{item.title}</Link>
                        </h5>
                        <p
                          className="lineClamp"
                          style={{
                            WebkitLineClamp: 3,
                          }}
                        >
                          {item.shorttext}
                        </p>
                        <Link
                          to={"/treatment/" + item.id}
                          className="btn-link primary-color"
                        >
                          Read More
                          <i className="fal fa-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </Slider>
          {/* Data */}
        </div>
      </div>
    );
  }
}

export default Treatments;
